/* eslint-disable max-len */
import { useState } from 'react';
import cn from 'classnames';

import arrowIcon from 'assets/images/arrow-down@3x.png';
import Button from 'components/form/Button.component';
import CheckboxInput from 'components/form/CheckboxInput.component';
import Icon from 'components/generic/Icon.component';
import useIsFromMobileApp from 'hooks/useIsFromMobileApp.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import ProductModal from 'settings/product-listing/components/ProductModal';
import SearchContainer from 'stocks/components/common/Search';

import CN from './HeaderStocksFilter.module.scss';

const HeaderStocksFilter = ({
  salonId,
  additionalClass = '',
  cssPosition,
  hasAnyProducts,
  selectedBrandCount,
  selectedSubBrandCount,
  selectedCategoryCount,
  showFilterByBrand,
  showFilterBySubBrand,
  showFilterByCategory,
  clearFilter,
  showLowProducts,
  lowInStock,
  onCheckLowInStock,
  onSearch,
  search,
  clearSearch,
  clearBtn,
  useProductModal,
  jsPdfGenerator,
  children,
}) => {
  const [addProductModal, setAddProductModal] = useState(false);

  const { t } = useTranslation();
  const isFromMobile = useIsFromMobileApp();
  const { isDarkMode } = useTheme();

  const addProduct = () => setAddProductModal(true);
  const cancelAddProduct = () => setAddProductModal(false);

  return (
    <>
      {addProductModal && (
        <div className="container-product-modal">
          <div className="overlay" role="button" tabIndex={0} onClick={cancelAddProduct} />
          <ProductModal popupTitle={t('stocks.managerLayout.addProductModal.title')} formType="create" cancel={cancelAddProduct} salonId={salonId} />
        </div>
      )}
      <div className={cn('stocks-filter-bar', additionalClass || '', { [CN.dark]: isDarkMode })}>
        <div className="scroll-bar">
          <div className={`scroll-content ${cssPosition}`}>
            {children}
            <div className="brand-filter-buttons">
              {hasAnyProducts && (
                <>
                  <span className="filter-label">{t('stocks.managerLayout.headerFilters.filters')}</span>
                  <span className={cn('filter-by-brand', { selected: selectedBrandCount >= 1 })} role="button" tabIndex={0} onClick={showFilterByBrand}>
                    {selectedBrandCount && <span className="selected-count">{selectedBrandCount}</span>}
                    {t('stocks.managerLayout.headerFilters.brand')}
                    <img src={arrowIcon} alt="Dropdown icon" />
                  </span>
                  <span className="brand-label">{t('stocks.managerLayout.headerFilters.and')}</span>
                  <span className={cn('filter-by-sub-brand', { selected: selectedSubBrandCount >= 1 })} role="button" tabIndex={0} onClick={showFilterBySubBrand}>
                    <span className="selected-count">{selectedSubBrandCount}</span>
                    {t('stocks.managerLayout.headerFilters.subBrand')}
                    <img src={arrowIcon} alt="" />
                  </span>
                  <span className="brand-label">{t('stocks.managerLayout.headerFilters.and')}</span>
                  <span className={cn('filter-by-category', { selected: selectedCategoryCount >= 1 })} role="button" tabIndex={0} onClick={showFilterByCategory}>
                    <span className="selected-count">{selectedCategoryCount}</span>
                    {t('stocks.managerLayout.headerFilters.category')}
                    <img src={arrowIcon} alt="" />
                  </span>
                </>
              )}
            </div>
            <div className="clear-filter">
              <Button variant="secondary" onClick={clearFilter}>
                <span className={CN.nowrap}> {t('stocks.managerLayout.headerFilters.clearFilter')}</span>
              </Button>
            </div>

            {showLowProducts && (
              <div className={CN.checkboxBoxWrap}>
                <CheckboxInput variant="tick" iconWidth="sm" checked={lowInStock} onClick={onCheckLowInStock}>
                  <span className={CN.cbText}>{t('stocks.managerLayout.headerFilters.showLowStock')}</span>
                </CheckboxInput>
              </div>
            )}

            {hasAnyProducts && onSearch && <SearchContainer currentText={search} onTextChange={onSearch} clearSearch={clearSearch} clearBtn={clearBtn} />}

            <div className={CN.buttonsContainer}>
              <Button variant="primary" width="medium" onClick={addProduct}>
                <span className={CN.nowrap}>{t('stocks.managerLayout.headerFilters.addProductButton')}</span>
              </Button>
              <Button variant="emphasis" width="medium" onClick={useProductModal}>
                <span className={CN.nowrap}> {t('stocks.managerLayout.headerFilters.useProductButton')}</span>
              </Button>
              {!isFromMobile && (
                <Button variant="icon" width="small" onClick={jsPdfGenerator}>
                  <Icon variant="download" width="lg" />
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderStocksFilter;
